module.exports = __webpack_public_path__ + "img/938-7be2fa.png";